import type { GenericTranslationsObject } from '@payloadcms/translations'

export const ta: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: 'கிட்டத்தட்ட முடிந்துவிட்டது',
    autoGenerate: 'தானாக உருவாக்கு',
    bestPractices: 'சிறந்த நடைமுறைகள்',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} எழுத்துகள், ',
    charactersLeftOver: '{{characters}} மீதம் உள்ளது',
    charactersToGo: '{{characters}} எழுத வேண்டும்',
    charactersTooMany: '{{characters}} அதிகமாக உள்ளது',
    checksPassing: '{{current}}/{{max}} சோதனைகள் வெற்றி',
    good: 'நன்று',
    imageAutoGenerationTip: 'தானியங்கு உருவாக்கம் தேர்ந்தெடுக்கப்பட்ட முக்கியப் படத்தை எடுக்கும்.',
    lengthTipDescription:
      'இது {{minLength}} மற்றும் {{maxLength}} எழுத்துகளுக்கு இடையில் இருக்க வேண்டும். தரமான மெட்டா விளக்கங்களை எழுத உதவிக்கு பார்க்கவும் ',
    lengthTipTitle:
      'இது {{minLength}} மற்றும் {{maxLength}} எழுத்துகளுக்கு இடையில் இருக்க வேண்டும். தரமான மெட்டா தலைப்புகளை எழுத உதவிக்கு பார்க்கவும் ',
    missing: 'இல்லை',
    noImage: 'படம் இல்லை',
    preview: 'முன்னோட்டம்',
    previewDescription:
      'சரியான முடிவு பட்டியல்கள் உள்ளடக்கம் மற்றும் தேடல் தொடர்புக்கு ஏற்ப மாறலாம்.',
    tooLong: 'மிக நீளம்',
    tooShort: 'மிகக் குறைவு',
  },
}
